module.exports = __webpack_public_path__ + "img/tours_3.58a00d14.jpg";